import { appUrl, isProduction, rootDomain } from '../services/env';

const protocol = process.env.NODE_ENV === 'production' ? 'https://' : 'http://';

export default function getSellerPortalUrl(seller) {
  if (!isProduction) {
    return `${appUrl}/s/${seller.name}/portal`;
  }

  if (seller.customDomain && seller.customDomainVerified) {
    return `${protocol}${seller.customDomain}/portal`;
  }

  return `${protocol}${seller.name}.${rootDomain}/portal`;
}
